import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Axios, { AxiosError } from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import Rodal from 'rodal';
import { API_URL } from '../../../../lib/const';
import { toast } from 'react-toastify';
import { InputCpf } from '../../../elements';
import { IApplication } from '../types';

type FindResult = 'found' | 'not found' | 'error'

type ApplicationProcessFinderModalProps = {
  cpf?: string,
  process?: number,
  onCompleteFind: (result: FindResult, application?: IApplication) => void
}

const ApplicationProcessFinderModal = ({ cpf, process, onCompleteFind }: ApplicationProcessFinderModalProps) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const unmakedCPF = (cpf || '').replace(/\D/g, "");
    if (unmakedCPF.length === 11 && process) {
      findApplication();

    }
  }, [cpf, process]);

  const handleCloseModal = () => {
    setShow(false);

  }

  const handleCompleteFind = (status: FindResult, application?: IApplication) => {
    onCompleteFind(status, application);
  }

  const findApplication = useCallback(async () => {
    const unmakedCPF = (cpf || '').replace(/\D/g, "");

    try {
      const response = await Axios.get(`${API_URL}/transfers/applications/find`, { params: { cpf: unmakedCPF, process } });
      setShow(true);
      handleCompleteFind('found', response.data);

    } catch (error) {
      const response = (error as AxiosError).response;

      if (response && response.status === 400) {
        handleCompleteFind('error');

      } else if (response && response.status === 404) {
        handleCompleteFind('not found')

      }
    }

  }, [cpf, process])

  return (
    <Rodal
      width={600}
      visible={show}
      showCloseButton={false}
      closeMaskOnClick={false}
      onClose={handleCloseModal}
    >
      <div className="d-flex flex-column h-100">
        <div className="modal-header">
          <div className="text-center">
            <h2>Inscrição encontrada.</h2>
          </div>
        </div>
        <div className="modal-body">
          <p>Encontramos uma inscrição para o seu CPF, iremos te direcionar para o seu processo.</p>
        </div>
      </div>
    </Rodal>
  )
}

export default ApplicationProcessFinderModal;
